<template>
  <section style="height:100vh" id="basicMap" class="map-wrapper">
   
   
    <e-map
      :properties="{
        basemap: 'streets'
      }"
      key="basicMap"
    >
      <e-map-view
        :properties="{
          container: 'basicMap',
          zoom: zoom,
          center: center
        }"
      >
        <e-basemap-toggle 
          :properties="{ nextBasemap: 'hybrid' }"
          position="bottom-right"
        />

        <!-- New additions -->
        
          <e-graphic v-for="i in item" :key="i.properties.OBJECTID" :properties="getPointProps(i.geometry.coordinates[0],i.geometry.coordinates[1],i.properties.PROPERTY_NAME_TEXT,i.properties.ADDRESS_LINE1_TEXT,i.properties.STD_CITY,i.properties.PROPERTY_ON_SITE_PHONE_NUMBER,i.properties.STD_ST,i.properties.STD_ZIP5)" />
      </e-map-view>
    </e-map>
    
  </section>
</template>

<script>

export default {
  props:['item','center'],
  data(){
    return {
      points:[{lng:-49.97,lat:41.73},{lng:-59.97,lat:51.73}],
      zoom:12
      
     
    }
  },
  methods: {
    
    getPointProps(lng,lat,name,address,city,phone,tx,zip) {
      // First create a point geometry (this is the location of the Titanic)
        var point = {
          type: "point", // autocasts as new Point()
          longitude: lng,
          latitude: lat
        };
        // Create a symbol for drawing the point
        var markerSymbol = {
          type: "simple-marker", // autocasts as new SimpleMarkerSymbol()
          color: [226, 119, 40],
          outline: {
            // autocasts as new SimpleLineSymbol()
            color: [255, 255, 255],
            width: 1
          }
        };

        
        // Create a graphic and add the geometry and symbol to it
        return {
          attributes: {
            name: 'Dot!'
          },
          popupTemplate: {
      // autocasts as new PopupTemplate()
      title: name,
      content: [
        {
          type: "fields",
          fieldInfos: [
            {
              fieldName: address+', '+city+', '+tx+' '+zip
            },
            {
              fieldName: phone
            }
           
          ]
        }
      ]
    },
          geometry: point,
          symbol: markerSymbol
        }
    },
    
  },
  mounted(){

  }
   
}
</script>

<style>

</style>